import {gsap} from "gsap";
import {ScrollTrigger} from "../../lib/_scroll-trigger";


const globalScrub = 1;
document.arrive('#time-2020 .block-3', {existing: true}, function() {
    const svg = this.querySelector('.svg-container svg');
    const svgBottomBreakpoint = {
        trigger: '#time-2020 .block-2',
        start: "top bottom", // when the top of the trigger hits the top of the viewport
        end: "bottom center", // when the top of the trigger hits the top of the viewport
        endTrigger: "#time-2020 .block-4", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false,
        onUpdate: (timeline)=> {
            const maxScale = 2.5;
            svgScale = (timeline.progress / 0.5 > 1 ? 1 - timeline.progress : timeline.progress) * (2 * maxScale);
            svg.style.transform = "scaleY(" + svgScale + ")"
        }
    }
    let svgScale = 2;

    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
            gsap.fromTo(
                svg,
                {
                    scrollTrigger: svgBottomBreakpoint
                },
                {
                    scrollTrigger: svgBottomBreakpoint
                }
            );
        },
        "(max-width: 991px) and (min-width: 769px)": function () {
            gsap.fromTo(
                svg,
                {
                    scrollTrigger: {
                        trigger: '#time-2020 .block-2',
                        start: "top bottom", // when the top of the trigger hits the top of the viewport
                        end: "bottom center", // when the top of the trigger hits the top of the viewport
                        endTrigger: "#time-2020 .block-4", // when the top of the trigger hits the top of the viewport
                        scrub: globalScrub
                    },
                    scaleX: 2,
                    x: "-15%",
                    scaleY: 4,
                    y: 0
                },
                {
                    scrollTrigger: {
                        trigger: '#time-2020 .block-2',
                        start: "top bottom", // when the top of the trigger hits the top of the viewport
                        end: "bottom center", // when the top of the trigger hits the top of the viewport
                        endTrigger: "#time-2020 .block-4", // when the top of the trigger hits the top of the viewport
                        scrub: globalScrub
                    },
                    scaleX: 2,
                    x: "-25%",
                    scaleY: 3,
                    y: "10vw"
                }
            );
        },
        "(max-width: 768px) and (min-width: 501px)": function () {
            gsap.fromTo(
                svg,
                {
                    scrollTrigger: {
                        trigger: '#time-2020 .block-2',
                        start: "top bottom", // when the top of the trigger hits the top of the viewport
                        end: "bottom center", // when the top of the trigger hits the top of the viewport
                        endTrigger: "#time-2020 .block-4", // when the top of the trigger hits the top of the viewport
                        scrub: globalScrub
                    },
                    scaleX: 2,
                    x: "-15%",
                    scaleY: 4,
                    y: 0
                },
                {
                    scrollTrigger: {
                        trigger: '#time-2020 .block-2',
                        start: "top bottom", // when the top of the trigger hits the top of the viewport
                        end: "bottom center", // when the top of the trigger hits the top of the viewport
                        endTrigger: "#time-2020 .block-4", // when the top of the trigger hits the top of the viewport
                        scrub: globalScrub
                    },
                    scaleX: 2,
                    x: "-25%",
                    scaleY: 3,
                    y: "15vw"
                }
            );
        },
        "(max-width: 500px)": function () {
            gsap.fromTo(
                svg,
                {
                    scrollTrigger: {
                        trigger: '#time-2020 .block-2',
                        start: "top bottom", // when the top of the trigger hits the top of the viewport
                        end: "bottom center", // when the top of the trigger hits the top of the viewport
                        endTrigger: "#time-2020 .block-4", // when the top of the trigger hits the top of the viewport
                        scrub: globalScrub
                    },
                    scaleX: 2,
                    x: "-15%",
                    scaleY: 4,
                    y: 0
                },
                {
                    scrollTrigger: {
                        trigger: '#time-2020 .block-2',
                        start: "top bottom", // when the top of the trigger hits the top of the viewport
                        end: "bottom center", // when the top of the trigger hits the top of the viewport
                        endTrigger: "#time-2020 .block-4", // when the top of the trigger hits the top of the viewport
                        scrub: globalScrub
                    },
                    scaleX: 2,
                    x: "-25%",
                    scaleY: 5,
                    skewY: "-20deg",
                    y: "15vw"
                }
            );
        }
    });
})

document.arrive('#time-2020 .block-1', {existing: true}, function() {
    const col1 = this.querySelector('.width-60');
    const col2 = this.querySelector('.width-40');
    const col1ImgContainer = col1.querySelector('.image');
    const col1Img = col1ImgContainer.querySelector('img');
    const col2Img = col2.querySelector('img');
    const img3 = this.querySelector('.bottom img');
    const col1tile = col1.querySelector('.tile');
    const time = col1.querySelector('.caption');
    const images = this.querySelectorAll('.image');

    const st = {
        trigger: this,
        start: "top 90%", // when the top of the trigger hits the top of the viewport
        end: "center center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };
    const st2 = {
        trigger: this,
        start: "center center", // when the top of the trigger hits the top of the viewport
        end: "bottom center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };
    const yearBreakpoint = Object.assign({}, st)
    yearBreakpoint["end"] = "bottom 60%";
    yearBreakpoint["start"] = "top 30%";

    gsap.from(
        col1tile,
        {
            scrollTrigger: st,
            y: 50
        }
    );
    images.forEach((image) => {
        const img = image.querySelector('img');

        ScrollTrigger.matchMedia({
            "(max-width: 991px)": function () {

                    gsap.from(
                        img,
                        {
                            scrollTrigger: {
                                trigger: img,
                                start: "top bottom", // when the top of the trigger hits the top of the viewport
                                end: "center center", // when the top of the trigger hits the top of the viewport
                                scrub: globalScrub
                            },
                            scale: 1.5
                        }
                    );

                    gsap.from(
                        image,
                        {
                            scrollTrigger: {
                                trigger: image,
                                start: "top bottom", // when the top of the trigger hits the top of the viewport
                                end: "center center", // when the top of the trigger hits the top of the viewport
                                scrub: globalScrub
                            },
                            scale: 0.8
                        }
                    );
            },
        });
    })

    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
            gsap.fromTo(
                time,
                {
                    scrollTrigger: yearBreakpoint,
                    y: -(col1ImgContainer.offsetHeight / 2) + (time.offsetHeight / 2) + 40,
                },
                {
                    scrollTrigger: yearBreakpoint,
                    y: (col1ImgContainer.offsetHeight / 2) - (time.offsetHeight / 2) - 40,
                }
            );

            gsap.from(
                col1Img,
                {
                    scrollTrigger: st,
                    scale: 1.4
                }
            );

            gsap.from(
                col2Img,
                {
                    scrollTrigger: st,
                    scale: 1.3
                }
            );

            gsap.from(
                img3,
                {
                    scrollTrigger: st2,
                    scale: 1.2
                }
            );
        }
    });
})

document.arrive('#time-2020 .block-2, #time-2020 .block-6', {existing: true}, function() {
    const imgContainer = this.querySelector('.image');
    const img = imgContainer.querySelector('img');

    const st = {
        trigger: this,
        start: "top center", // when the top of the trigger hits the top of the viewport
        end: "60% center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };

    gsap.from(
        img,
        {
            scrollTrigger: st,
            scale: "1.6"
        }
    );

    gsap.from(
        imgContainer,
        {
            scrollTrigger: st,
            scale: "0.8",
            y: '-10%'
        }
    );
})

document.arrive('#time-2020 .block-8', {existing: true}, function() {
    const imgContainer = this.querySelector('.image');
    const img = imgContainer.querySelector('img');
    const year = this.querySelector('.year');

    const st = {
        trigger: this,
        start: "top 90%", // when the top of the trigger hits the top of the viewport
        end: "bottom 10%", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };
    const yearBreakpoint = Object.assign({}, st)
    yearBreakpoint["end"] = "bottom 80%";
    yearBreakpoint["start"] = "top 60%";

    gsap.from(
        imgContainer,
        {
            scrollTrigger: st,
            scale: "0.8"
        }
    );

    gsap.from(
        img,
        {
            scrollTrigger: st,
            scale: "1.4"
        }
    );

    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
            gsap.to(
                year,
                {
                    scrollTrigger: yearBreakpoint,
                    scale: 1.4,
                    color: "#fff",
                    textShadow: "0 20px 75px rgba(0,0,0,0.7)",
                    y: imgContainer.clientHeight - year.offsetHeight,
                }
            );
        }
    });
})

document.arrive('#time-2020 .block-3', {existing: true}, function() {
    const imgContainer = this.querySelector('.image');
    const img = imgContainer.querySelector('img');

    const st = {
        trigger: this,
        start: "top center", // when the top of the trigger hits the top of the viewport
        end: "60% center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };
    gsap.from(
        img,
        {
            scrollTrigger: st,
            scale: "1.6"
        }
    );

    ScrollTrigger.matchMedia({
        "(max-width: 991px)": function () {
            gsap.from(
                imgContainer,
                {
                    scrollTrigger: st,
                    scale: "0.8"
                }
            );
        }
    });
})

document.arrive('#time-2020 .block-5, #time-2020 .block-7', {existing: true}, function() {
    const imgContainer = this.querySelector('.logo');
    const img = imgContainer.querySelector('img');

    const st = {
        trigger: this,
        start: "top center", // when the top of the trigger hits the top of the viewport
        end: "center center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };

    gsap.from(
        img,
        {
            scrollTrigger: st,
            scale: "1.6"
        }
    );
})

document.arrive('#time-2020 .block-11', {existing: true}, function() {
    const imgContainer = this.querySelector('.image');
    const img = imgContainer.querySelector('img');

    const st = {
        trigger: this,
        start: "top 90%", // when the top of the trigger hits the top of the viewport
        end: "center center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };

    gsap.from(
        img,
        {
            scrollTrigger: st,
            scale: "1.4"
        }
    );


    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
            gsap.from(
                imgContainer,
                {
                    scrollTrigger: st,
                    scale: "0.9",
                    x: "10vw"
                }
            );
        },
        "(max-width: 991px)": function () {
            gsap.from(
                imgContainer,
                {
                    scrollTrigger: st,
                    scale: "0.9"
                }
            );
        }
    });
});


document.arrive('#time-2020 .block-5, #time-2020 .block-4, #time-2020 .block-7, #time-2020 .block-9', {existing: true}, function() {
    const dividers = this.querySelectorAll('.divider');
    dividers.forEach((div) => {
        const dividerBreakpoint = {
            trigger: div,
            start: "top center", // when the top of the trigger hits the top of the viewport
            end: "bottom center", // when the top of the trigger hits the top of the viewport
            endTrigger: div,
            scrub: globalScrub,
        }

        gsap.from(
            div,
            {
                scrollTrigger: dividerBreakpoint,
                scale: 0
            }
        );
    });
})

document.arrive('#time-2020 .block-10', {existing: true}, function() {
    const imgContainer = this.querySelector('.image');
    const img = imgContainer.querySelector('img');

    const st = {
        trigger: this,
        start: "top center", // when the top of the trigger hits the top of the viewport
        end: "center center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };

    gsap.from(
        img,
        {
            scrollTrigger: st,
            scaleY: "1.66"
        }
    );

    gsap.from(
        imgContainer,
        {
            scrollTrigger: st,
            y: '-20%',
            scaleY: "0.6"
        }
    );
})
//
// document.arrive('#time-2020 .block-12', {existing: true}, function() {
//     const imgContainer = this.querySelector('.image');
//     const img = imgContainer.querySelector('img');
//
//     const st = {
//         trigger: this,
//         start: "top center", // when the top of the trigger hits the top of the viewport
//         end: "center center", // when the top of the trigger hits the top of the viewport
//         scrub: globalScrub,
//         markers: false
//     };
//
//     gsap.from(
//         img,
//         {
//             scrollTrigger: st,
//             scaleY: "1.66"
//         }
//     );
//
//     gsap.from(
//         imgContainer,
//         {
//             scrollTrigger: st,
//             y: '-20%',
//             scaleY: "0.6"
//         }
//     );
// })
//
// document.arrive('#time-2020 .block-13', {existing: true}, function() {
//     const col1 = this.querySelector('.width-50:first-child');
//     const col2 = this.querySelector('.width-50:last-child');
//     const col2ImgContainer = col2.querySelector('.image');
//     const col2Img = col2ImgContainer.querySelector('img');
//     const col2tile = col2.querySelector('.tile');
//     const time = col1.querySelector('.time');
//     const svg = this.querySelector('.svg-container svg');
//     const st = {
//         trigger: this,
//         start: "top 90%", // when the top of the trigger hits the top of the viewport
//         end: "center center", // when the top of the trigger hits the top of the viewport
//         scrub: globalScrub,
//         markers: false
//     };
//     const yearBreakpoint = Object.assign({}, st)
//     yearBreakpoint["end"] = "bottom 60%";
//     yearBreakpoint["start"] = "top 30%";
//     let svgScale = 2;
//
//     gsap.from(
//         col2tile,
//         {
//             scrollTrigger: st,
//             y: 50
//         }
//     );
//
//     gsap.from(
//         col2Img,
//         {
//             scrollTrigger: st,
//             scale: 1.4
//         }
//     );
//
//     ScrollTrigger.matchMedia({
//         "(min-width: 992px)": function () {
//             gsap.to(
//                 time,
//                 {
//                     scrollTrigger: yearBreakpoint,
//                     y: col2ImgContainer.offsetHeight - time.offsetHeight,
//                 }
//             );
//         }
//     });
// })

document.arrive('#time-2020 .block-12', {existing: true}, function() {
    const img1 = this.querySelector('.width-40 .image img');
    const img2Container = this.querySelector('.width-50 .image');
    const img2 = img2Container.querySelector('img');
    const st = {
        trigger: this,
        start: "top 90%", // when the top of the trigger hits the top of the viewport
        end: "center center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };

    gsap.from(
        img1,
        {
            scrollTrigger: st,
            scale: 1.4
        }
    );

    gsap.from(
        img2,
        {
            scrollTrigger: {
                trigger: img2Container,
                start: "top center", // when the top of the trigger hits the top of the viewport
                end: "center center", // when the top of the trigger hits the top of the viewport
                scrub: globalScrub,
                markers: false
            },
            scale: 1.6
        }
    );

    gsap.from(
        img2Container,
        {
            scrollTrigger: {
                trigger: img2Container,
                start: "top center", // when the top of the trigger hits the top of the viewport
                end: "center center", // when the top of the trigger hits the top of the viewport
                scrub: globalScrub,
                markers: false
            },
            scale: 0.8
        }
    );
})

document.arrive('#time-2020 .block-13, #time-2020 .block-14', {existing: true}, function() {
    const imgContainer = this.querySelector('.image');
    const img = imgContainer.querySelector('img');

    const st = {
        trigger: this,
        start: "top center", // when the top of the trigger hits the top of the viewport
        end: "60% center", // when the top of the trigger hits the top of the viewport
        scrub: globalScrub,
        markers: false
    };
    gsap.from(
        img,
        {
            scrollTrigger: st,
            scale: "1.6"
        }
    );

    ScrollTrigger.matchMedia({
        "(max-width: 991px)": function () {
            gsap.from(
                imgContainer,
                {
                    scrollTrigger: st,
                    scale: "0.8"
                }
            );
        }
    });
})